import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=7f36c318&scoped=true"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=7f36c318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36c318",
  null
  
)

export default component.exports